import { postAsync,getAsync } from "./http-client";

const CmmApi = {
  getManagerCodeByShopIdx: async (shopIdx) => {
    const res = await getAsync(`/cmmn/managerCode/shopIdx/${shopIdx}`);
    return res.data.data;
  },
};
export default CmmApi;
